"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCurrency = void 0;
const big_1 = __importDefault(require("@swyftx/big"));
const getPriceScale_1 = require("./getPriceScale");
const defaultOptions = {
    isFiat: true,
    currency: 'AUD',
    appendCurrency: false,
    significantDigits: getPriceScale_1.DEFAULT_SIGNIFICANT_DIGITS,
    minimumFractionDigits: 2,
};
const formatCurrency = (amount, options = defaultOptions) => {
    const { isFiat, currency, appendCurrency, priceScaleOverride, significantDigits, minimumFractionDigits, } = {
        ...defaultOptions,
        ...options,
    };
    const priceScale = priceScaleOverride ?? (0, getPriceScale_1.getPriceScale)(amount, significantDigits);
    /*
      Maximum digits in this case refers to the amount of non zero decimals visible. i.e
      maximumSignificantDigits: 5 with a price of $20,000.123123123 would simply return $20,000.
      To fix this, we are passing 16 to ensure we always have enough digits formatted when we round.
      If this becomes problematic in the future. The solution may be to dynamically calculate it by getting the
      amount of digits before the period and then adding the significantDigits value
    */
    const formatter = new Intl.NumberFormat(isFiat ? 'en-AU' : undefined, {
        style: isFiat ? 'currency' : undefined,
        currency: isFiat ? currency : undefined,
        maximumSignificantDigits: getPriceScale_1.MAX_PRICE_SCALE,
    });
    let formattedText = formatter.format(new big_1.default(amount).round(priceScale).toNumber());
    if (minimumFractionDigits && formattedText) {
        const splitText = formattedText.split('.');
        const digits = splitText?.[0]?.length;
        const decimals = splitText?.[1]?.length || 0;
        const notEnoughDecimals = decimals < minimumFractionDigits;
        if (!decimals)
            formattedText = formattedText.padEnd(digits + 1, '.');
        if (notEnoughDecimals) {
            formattedText = formattedText.padEnd(digits + 1 + minimumFractionDigits, '0');
        }
    }
    if (appendCurrency)
        formattedText = `${formattedText} ${currency}`;
    return formattedText;
};
exports.formatCurrency = formatCurrency;
//# sourceMappingURL=formatCurrency.js.map